import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

// Internals
import { TODO } from '../../types';
import { Column, Columns } from '../../components/Grid';
import Select from './add/Select';
import Sync from './add/Sync';
import Customize from './add/Customize';

// Antd
import { Button, Divider, message, PageHeader, Space, Steps } from 'antd';

// Icons
import { X } from 'react-feather';

// Firebase
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase';

// Misc
import LOGO from '../../img/logo.svg';
import { get } from 'lodash-es';

// Styles
import styles from './add.module.scss';
import sharedStyles from './add/shared.module.scss';

const { Step } = Steps;

export default function AddAccount() {
  const navigate = useNavigate();

  const [user, loading, error] = useAuthState(auth);

  const [current, setCurrent] = React.useState(0);
  const [selectedAccount, setSelectedAccount] = React.useState<any>({});
  const [addresses, setAddresses] = React.useState<object[] | null>(null);

  const onSelect = (account: any) => {
    setCurrent(1);
    setSelectedAccount(account);
  };

  const onSync = (addrs = null) => {
    setAddresses(addrs || [{}, {}, {}, {}, {}]);

    setCurrent(2);
  };

  const onConnect = () => {
    fetch(process.env.REACT_APP_API_URL + '/accounts', {
      method: 'post',
      headers: new Headers({
        Authorization: 'Basic ' + (user as any).accessToken,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(
        addresses
          ?.filter((addr: TODO) => addr.wallet_address !== undefined && addr.name !== undefined)
          .map((addr) => ({
            chain: 'ethereum',
            type: 'wallet',
            source: 'ethereum',
            address: get(addr, 'wallet_address'),
            name: get(addr, 'name'),
            provider: selectedAccount.name.toLowerCase(),
          })),
      ),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        return Promise.reject(response);
      })
      .then((data) => {
        message.success('Successfully added!');

        navigate('/accounts');

        console.log('Data', data);
      })
      .catch((response) => {
        response.json().then((error: any) => {
          console.log('Error', error);

          message.error('Something went wrong');
        });
      });
  };

  const steps = [
    {
      title: 'Select',
      content: <Select onSelect={onSelect} />,
    },
    {
      title: 'Sync',
      content: <Sync onSync={onSync} onConnect={onConnect} selectedAccount={selectedAccount} />,
    },
    ...(selectedAccount === {} || selectedAccount.name !== 'Anchorage'
      ? [
          {
            title: 'Customize',
            content: (
              <Customize
                addresses={addresses}
                setAddresses={setAddresses}
                selectedAccount={selectedAccount}
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <div className={styles.container}>
      <PageHeader ghost={false}>
        <Columns className="is-mobile">
          <Column
            className={styles.logo}
            style={{
              flexGrow: 1,
            }}
          >
            <Link to="/">
              <img src={LOGO} />
            </Link>
          </Column>

          <Column className={styles.steps}>
            <Steps current={current}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
          </Column>

          <Column
            className={styles['close-icon']}
            style={{
              flexGrow: 1,
              textAlign: 'right',
            }}
          >
            <Button
              icon={
                <X
                  style={{
                    margin: 0,
                    marginTop: '-0.15rem',
                  }}
                />
              }
              onClick={() => navigate('/accounts')}
            ></Button>
          </Column>
        </Columns>
      </PageHeader>

      <Divider />

      {steps[current].content}

      <div className={sharedStyles['wizard-footer']}>
        <Divider />

        <Space direction="horizontal" style={{ width: '100%', justifyContent: 'end' }}>
          {current === 0 && (
            <Button type="default" onClick={() => navigate('/accounts')}>
              Cancel
            </Button>
          )}

          {current !== 0 && (
            <>
              <Button type="default" onClick={() => setCurrent(current > 0 ? current - 1 : 0)}>
                Back
              </Button>

              <Button
                type="primary"
                form="SyncForm"
                htmlType="submit"
                onClick={current === steps.length - 1 ? onConnect : undefined}
              >
                Sync
              </Button>
            </>
          )}
        </Space>
      </div>
    </div>
  );
}
